// extracted by mini-css-extract-plugin
export default {"formWrp":"AddForm_formWrp__b2o-Q","form":"AddForm_form__giF8Q","title":"AddForm_title__m0PVc"};